import { render, staticRenderFns } from "./aiCard.vue?vue&type=template&id=1c674440&scoped=true"
import script from "./aiCard.vue?vue&type=script&lang=js"
export * from "./aiCard.vue?vue&type=script&lang=js"
import style0 from "./aiCard.vue?vue&type=style&index=0&id=1c674440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c674440",
  null
  
)

export default component.exports